export default __webpack_public_path__ + "static/media/Arrow Right.c1cbcd70.svg";